import { Search } from "lucide-react";

import { Input } from "@/shared/ui/input";

/**
 * 历史节的任务名搜索框(2026-07-16 三线统一)。
 *
 * <p>此前三线各贴一份一模一样的 relative+absolute icon+Input 结构,只有 placeholder 不同 —— 正是「下次又漂」的来源。
 *
 * <p>搜索下推后端 name LIKE 全表搜(不是前端过滤当前页),故它只属于**历史**节:在途任务由顶部节独立拉取,
 * 不参与搜索。放在历史节标题行里,位置本身就在说明它筛的是谁。
 */
export function MediaSearchBox({
  value,
  onChange,
  placeholder,
}: {
  value: string;
  onChange: (v: string) => void;
  placeholder: string;
}) {
  return (
    <div className="relative">
      <Search className="absolute left-2.5 top-1/2 h-3.5 w-3.5 -translate-y-1/2 text-muted-foreground" />
      <Input
        className="h-8 w-44 pl-8 text-xs"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
    </div>
  );
}
